import { render, staticRenderFns } from "./_productTermModal.vue?vue&type=template&id=316a50ee"
import script from "./_productTermModal.vue?vue&type=script&lang=js"
export * from "./_productTermModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports